<template>
  <div class="main-wrapper">
    <layoutheader />
    <indexsixbanner />
    <div class="content doctor-content">
      <div class="container">
        <div class="row" style="    margin-top: -130px;
    position: relative;
    z-index: 1;">
          <doctorsidebar></doctorsidebar>
          <div class="col-lg-8 col-xl-9">

            <!-- Settings List -->
            <settings-tabs></settings-tabs>
            <!-- /Settings List -->

            <div class="dashboard-header">
              <h5>Certificaciones</h5>
            </div>

            <div class="row" style="margin-bottom: 30px;">
              <div class="col-lg-3" style="margin-bottom: 20px;">
                <div class="awards-slider owl-carousel">
                  <div class="award-card text-start">
                    <div class="award-card-info">
                      <span>
                        <img
                          src="@/assets/img/icons/bookmark-star.svg"
                          alt="Img"
                        />
                      </span>
                      <p>
                        Certificación en Cirugía Robótica / Certificate of Training Equivalency as a Resident or Fellow
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3" style="margin-bottom: 20px;">
                <div class="awards-slider owl-carousel">
                  <div class="award-card text-start">
                    <div class="award-card-info">
                      <span>
                        <img
                          src="@/assets/img/icons/bookmark-star.svg"
                          alt="Img"
                        />
                      </span>
                      <p>
                        Certificación del Consejo Mexicano de Cirugía General por 5 años 2016-2021
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3" style="margin-bottom: 20px;">
                <div class="awards-slider owl-carousel">
                  <div class="award-card text-start">
                    <div class="award-card-info">
                      <span>
                        <img
                          src="@/assets/img/icons/bookmark-star.svg"
                          alt="Img"
                        />
                      </span>
                      <p>
                        Certificación del Consejo Mexicano de Especialistas en Coloproctología A.C. por 5 años 2018-2023
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3" style="margin-bottom: 20px;">
                <div class="awards-slider owl-carousel">
                  <div class="award-card text-start">
                    <div class="award-card-info">
                      <span>
                        <img
                          src="@/assets/img/icons/bookmark-star.svg"
                          alt="Img"
                        />
                      </span>
                      <p>
                        Certificación como miembro de la American Society of Colon and Rectal Surgeons
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-5 d-flex">
                <div class="dashboard-card w-100">
                  <div class="dashboard-card-head">
                    <div class="header-title">
                      <h5>Docencia</h5>
                    </div>
                  </div>
                  <div class="dashboard-card-body">
                    <div class="clinic-available">
                      <div class="available-time">
                        <ul style="padding-left: 0rem;">
                          <li>
                            Profesor / Tutor del curso de Coloproctología en el Programa Único Especializado de Preparación Para el Examen Nacional de Aspirantes a Residencias Médicas (PUEP-ENARM) 2017
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="clinic-available">
                      <div class="available-time">
                        <ul style="padding-left: 0rem;">
                          <li>
                            Profesor Adjunto / Curso de Especialidad en Cirugía General en el Centro Médico Naval / Universidad Naval, septiembre del 2022 a marzo del 2024.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="clinic-available">
                      <div class="available-time">
                        <ul style="padding-left: 0rem;">
                          <li>
                            Instructor al curso de iniciación práctica en Cirugía Endoscópica IX Curso de formación básica en cirugía laparoscópica para residentes de cirugía general y del aparato digestivo. Asociación Española de Cirujanos, Febrero 2018.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="clinic-available">
                      <div class="available-time">
                        <ul style="padding-left: 0rem;">
                          <li>
                            Sinodal en el Examen de Certificación del Consejo Mexicano de Especialistas en Coloproctología A. C., Febrero del 2024
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-7">
                <div class="dashboard-card w-100">
                  <div class="dashboard-card-head">
                    <div class="header-title">
                      <h5>Distinciones Académicas</h5>
                    </div>
                    <!-- <div class="card-view-link">
                      <a href="javascript:void(0);">View All</a>
                    </div> -->
                  </div>
                  <div class="dashboard-card-body">
                    <div class="table-responsive">
                      <table class="table dashboard-table">
                        <tbody>
                          <tr>
                            <td>
                              <div class="table-noti-info">
                                <div class="table-noti-icon color-violet">
                                  <i class="fa-solid fa-star"></i>
                                </div>

                                <div class="table-noti-message">
                                  <span class="message-time">Mención como: “Alumno Sobresaliente” en la Licenciatura de Médico Cirujano UAG: 2005-2008</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="table-noti-info">
                                <div class="table-noti-icon color-blue">
                                  <i class="fa-solid fa-star"></i>
                                </div>

                                <div class="table-noti-message">
                                  <span class="message-time">Jefe de Residentes INCMNSZ: 2015-2016</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="table-noti-info">
                                <div class="table-noti-icon color-red">
                                  <i class="fa-solid fa-star"></i>
                                </div>

                                <div class="table-noti-message">
                                  <span class="message-time">Beca de Investigación: 2015 Fundación Cruz Azul</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="table-noti-info">
                                <div class="table-noti-icon color-yellow">
                                  <i class="fa-solid fa-star"></i>
                                </div>

                                <div class="table-noti-message">
                                  <span class="message-time">Crónica en el periódico italiano: PADOVAOGGI. </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="table-noti-info">
                                <div class="table-noti-icon color-green">
                                  <i class="fa-solid fa-star"></i>
                                </div>

                                <div class="table-noti-message">
                                  <span class="message-time">Constancia “Laureate” por Alto Rendimiento Académico en estudios de Maestría 2020-2022 </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="dashboard-card w-100">
                  <div class="dashboard-card-head">
                    <div class="header-title">
                      <h5>Diplomados</h5>
                    </div>
                    <!-- <div class="card-view-link">
                      <a href="javascript:void(0);">View All</a>
                    </div> -->
                  </div>
                  <div class="">
                    <div class="dashboard-content-info">
                      <h6>Administración en Salud </h6>
                      <h4></h4>
                      <span class="text-success"
                        >Abril 2021- Octubre 2021</span
                      >
                    </div>
                    <div class="dashboard-widget-icon">
                      <span class="dash-icon-box"
                        >Universidad Anáhuac; Ciudad de México, México</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            

            

            <!-- <form @submit.prevent="submitForm">
              <div class="accordions awrad-infos" id="list-accord">
                <div class="user-accordion-item" v-for="item in socialMedia" :key="item.id">
                  <a href="javascript:void(0);" class="accordion-wrap" data-bs-toggle="collapse"
                    data-bs-target="#award1" @click="deleteEvent(socialMedia)">Awards<span>Delete</span></a>
                  <div class="accordion-collapse collapse show" id="award1" data-bs-parent="#list-accord">
                    <div class="content-collapse">
                      <div class="add-service-info">
                        <div class="add-info">
                          <div class="row align-items-center">
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Award Name</label>
                                <input type="text" class="form-control" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Year <span class="text-danger">*</span></label>
                                <div class="form-icon">
                                  <datepicker v-model="startdate" class="datetimepicker form-control" :editable="true"
                                    :clearable="false" :input-format="dateFormat" />
                                  <span class="icon"><i class="fa-regular fa-calendar-days"></i></span>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Description
                                  <span class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-end">
                          <a href="javascript:void(0);" class="reset more-item">Reset</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                

                
                <div class="user-accordion-item">
                  <a href="javascript:void(0);" class="collapsed accordion-wrap" data-bs-toggle="collapse"
                    data-bs-target="#award2">Best Surgeon<span>Delete</span></a>
                  <div class="accordion-collapse collapse" id="award2" data-bs-parent="#list-accord">
                    <div class="content-collapse">
                      <div class="add-service-info">
                        <div class="add-info">
                          <div class="row align-items-center">
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Award Name</label>
                                <input type="text" class="form-control" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <label class="col-form-label">Year <span class="text-danger">*</span></label>
                                <div class="form-icon">
                                  <datepicker v-model="startdateOne" class="datetimepicker form-control"
                                    :editable="true" :clearable="false" :input-format="dateFormat" />
                                  <span class="icon"><i class="fa-regular fa-calendar-days"></i></span>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Description
                                  <span class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-end">
                          <a href="javascript:void(0);" class="reset more-item">Reset</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="modal-btn text-end">
                <a href="javascript:void(0);" class="btn btn-gray">Cancel</a>
                <button type="submit" class="btn btn-primary prime-btn">
                  Save Changes
                </button>
              </div>
            </form> -->
            <!-- /Profile Settings -->
          </div>
        </div>
      </div>
    </div>
    <indexfooter></indexfooter>
    <cursor></cursor>
    <scrolltotop />
  </div>
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  data() {
    return {
      title: "Curriculum",
      text: "Home",
      text1: "Curriculum",
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
      socialMedia: [
        {
          id: 1,
        },
      ],
    };
  },
  methods: {
    deleteEvent: function (socialMedia) {
      this.socialMedia.splice(this.socialMedia.indexOf(socialMedia), 1);
    },
    add() {
      const newId = this.socialMedia.length + 1;
      this.socialMedia.push({
        id: newId,
      });
    },
    submitForm() {
      this.$router.push("/doctor-awards-settings");
    },
  },
};
</script>
